import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzIconModule } from 'ng-zorro-antd/icon';

import { PipesModule } from '../../pipes/pipes.module';

import { SchainSourceCompaniesComponent } from './schain-source-companies.component';

@NgModule({
  declarations: [SchainSourceCompaniesComponent],
  imports: [
    CommonModule,
    NzCheckboxModule,
    FormsModule,
    NzInputModule,
    NzIconModule,
    PipesModule,
    NzToolTipModule
  ],
  exports: [SchainSourceCompaniesComponent]
})
export class SchainSourceCompaniesModule { }
